<script setup lang="ts">
import { toRefs } from 'vue';
import { useField } from 'vee-validate';

const props = defineProps({
	id: String,
	class: String,
	containerClass: String,
	name: String,
	defaultValue: Boolean,
});

// we are using toRefs to create reactive references to `name` and `value` props
// this is important because vee-validte needs to know if any of these props change
// https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
const { name } = toRefs(props);
// eslint-disable-next-line vue/no-dupe-keys
const { handleChange, value } = useField(name);

const toggle = () => {
	handleChange(!value.value);
};
</script>

<template>
	<div class="checkbox-wrapper" @click="toggle">
		<div class="flex items-center" :class="props.containerClass">
			<span class="checkbox-box" :class="{ checked: defaultValue ? defaultValue : value === true }">
				<svg v-if="defaultValue ? defaultValue : value === true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="check-icon">
					<polyline points="20 6 9 17 4 12"></polyline>
				</svg>
			</span>
			<span class="cursor-pointer text-center">
				<slot />
			</span>
		</div>
		<input type="hidden" :name="name" :value="defaultValue ? defaultValue : value" />
	</div>
</template>

<style lang="scss" scoped>
.checkbox-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
}

.checkbox-box {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	flex-shrink: 0;
	margin-right: 8px;
	border: 2px solid currentColor;
	border-radius: 4px;
	cursor: pointer;

	&.checked {
		background: currentColor;

		.check-icon {
			width: 14px;
			height: 14px;
			filter: invert(1);
		}
	}
}
</style>
